import React, { useEffect } from 'react'
import { UIStore } from '../stores/UIStore'
import { colors } from '../variables'
import { Container, Row, Col } from 'react-grid-system'
import styled from 'styled-components'

const Contact = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.green)
    UIStore.setFooterBg(colors.white)
  }, [])

  return (
    <>
      <LandingArea />
    </>
  )
}

const LandingArea = () => (
  <LandingHolder>
    <Container>
      <Row>
        <Col xs={10}>
          <h1>Kontakta oss</h1>
        </Col>
      </Row>
    </Container>
  </LandingHolder>
)

const LandingHolder = styled.div`
  padding-top: 140px;
  box-sizing: border-box;
`

export default Contact
